import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# if else if tutorial For Beginners</title>
 <meta name="description" content="C# if else if tutorial for beginners.if else if in C# is used for making a decision. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# if else if,c# if else if for,c sharp if else if,c# if else if for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,if else if foreach c#,c# foreach if else if,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-if-else-if" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">If-else-if in CSharp</h1>
    <div className="first">
        <a href="/csharp-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-conditional-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>




<h2 className='headings'>if-else-if in CSharp(C#) Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}{"\n"}
            <span className="qwerty-4">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            <span className="qwerty-6">Else</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Else</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a program to Check maximum no between three no in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">namespace </span>
            <span className="qwerty-6">if</span>
            <span className="qwerty-3"> else </span>
            <span className="qwerty-6">if</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-3">program</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-5"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-7">ab</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty">cd</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-2">ef</span>
            <span className="qwerty-3">;</span>
            {"\n"}

            <span className="qwerty-7">ab </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-1">20</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty">cd </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-1">40</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2">ef </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-1">60</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-6">if</span>
            <span className="qwerty-3"> (</span>

            <span className="qwerty-7">ab </span>
            <span className="qwerty-1">&#62; </span>

            <span className="qwerty">cd </span>
            <span className="qwerty-4"> &&  </span>

            <span className="qwerty-7">ab </span>
            <span className="qwerty-1">&#62; </span>

            <span className="qwerty-2">ef</span>
            <span className="qwerty-3">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">ab</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-6">else if</span>
            <span className="qwerty-3"> (</span>

            <span className="qwerty">cd </span>
            <span className="qwerty-1">&#62; </span>

            <span className="qwerty-7">ab </span>
            <span className="qwerty-4"> &&  </span>

            <span className="qwerty">cd </span>
            <span className="qwerty-1">&#62; </span>

            <span className="qwerty-2">ef</span>
            <span className="qwerty-3">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty">cd</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125;</span>
            {"\n"}
            <span className="qwerty-6">else</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-1">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">ef</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">ef</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program to Check no is positive, negative, zero in CSharp(C#)?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">namespace </span>
            <span className="qwerty-6">if</span>
            <span className="qwerty-3"> else </span>
            <span className="qwerty-6">if</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-6">program</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-5"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123;</span>
            {"\n"}
            <span className="qwerty-5">  int </span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-1">45</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">if</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-1">0</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty">negative</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">else </span>
            <span className="qwerty-6">if</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-3"> &#62;</span>
            <span className="qwerty-1"> 0</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty">positive</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">else</span>
            {"\n"}
            <span className="qwerty-1">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty">zero</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}
            <span className="qwerty-4"> &#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">positive</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/csharp-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-conditional-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csifelseif;